import { Avatar, Box, Button, Checkbox, FormControl, IconButton, InputAdornment, InputLabel, MenuItem, Select, TextField, Tooltip, Typography } from '@mui/material';
import { AddBox1 } from '../../../../../../core/global/Icons';
import { Remove } from '@mui/icons-material';
import { QRCodeSVG } from "qrcode.react";
import { useRef } from 'react';
import { useEffect } from 'react';
import {Close, ContentCopy} from '@mui/icons-material';

export const Content = ({handlerChange, marketing_camp, }) => {
    const { form, job, copied, required } = marketing_camp
    const inputs = form.data
    const taglineRef = useRef();
    const company_logoRef = useRef();
    const work_locationRef = useRef();
    const job_vacancyRef = useRef();
    const qualificationRef = useRef();
    const ft_imageRef = useRef();

    const handlerAddRemove = (action, i) => {
        const updatedQualification = [...form.data.qualification]
        if (action === 'add') {
            updatedQualification.push({value: '', stat: true, msg: 'This field is required'})
            form.set({...form.data, 'qualification' : updatedQualification})
        }else{
            updatedQualification.splice(i, 1)
            form.set({...form.data, 'qualification' : updatedQualification})
        }
    }

    const handlerQualiChange = (e, i) => {
        const { value }  = e.target
        const updatedQualification = [...form.data.qualification]
        updatedQualification[i] = {
            ...updatedQualification[i],
            value: value,
            stat: value.trim() === "" ? true : false,
            msg: value.trim() === "" ? 'This field is required.' : ''
        }
        form.set({...form.data, 'qualification' : updatedQualification})
    }

    const jobLink = `${process.env.REACT_APP_CAREER_JOB_URL}/${window.btoa(`id_${inputs.job_vacancy}`)}`;

    const handleCopy = () => {
        navigator.clipboard.writeText(jobLink).then(() => {
        copied.set(true);
        setTimeout(() => copied.set(false), 2000);
        });
    };

    const refs = {
        company_logo: company_logoRef,
        tagline: taglineRef,
        work_location: work_locationRef,
        job_vacancy: job_vacancyRef,
        qualification: qualificationRef,
        ft_image: ft_imageRef,
    };

    useEffect(() => {
        const firstMissingField = required.data[0];
        const fieldRef = refs[firstMissingField];
        if (fieldRef?.current) {
            fieldRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
            fieldRef.current.focus();
        }
        // eslint-disable-next-line
    }, [required.data])
    return (
        <Box display="flex" flexDirection="column" gap="16px">
            <Typography fontWeight={600}>Company Logo</Typography>
            <Box display="flex" flexDirection="column" alignItems="center" gap="16px">
                <Avatar src={inputs.company_logo.object === "" ? inputs.company_logo.value : inputs.company_logo.object} alt="company-logo" 
                    sx={{maxWidth: 80, maxHeight: 80, border: inputs.company_logo.type === 'default' ? "1px solid red" : "0px"}}
                />
                {
                    inputs.company_logo.type === 'default' &&
                        <Box fontSize={14} color="red" textAlign="center">Change the default Company Logo</Box>
                }
                <label htmlFor="logo">
                    <Button variant="contained" component="span" ref={company_logoRef}
                        sx={{
                            bgcolor: '#f0f0f0',
                            color: '#000',
                            '&:hover': { bgcolor: '#e0e0e0' },
                        }}
                    >
                        Change
                    </Button>
                </label>
                <input type="file" accept="image/*" id="logo" hidden name="company_logo" onChange={handlerChange} />
            </Box>
            <TextField label="Company Name" size='small' name="company_name" value={inputs.company_name} onChange={handlerChange} />
            <TextField label="Tagline" ref={taglineRef} name="tagline" value={inputs.tagline} error={inputs.tagline.trim() === ''} onChange={handlerChange}
                multiline
                maxRows={3}
                minRows={3}
            />
            <TextField label="Work Location" ref={work_locationRef} size='small' name="work_location" value={inputs.work_location} onChange={handlerChange} 
                error={inputs.work_location.trim() === ''}
            />
            <Box display="flex" alignItems="center" gap="8px">
                <Checkbox name="with_job_acc" checked={inputs.with_job_acc} onChange={handlerChange} />
                <Typography fontSize={14}>With POFJob Accounts and Job Vacancies?</Typography>
            </Box>
            {
                inputs.with_job_acc ?
                    <FormControl fullWidth size="small">
                        <InputLabel id="job_label">Job Vacancy</InputLabel>
                        <Select labelId="job_label" label="Job Vacancy" name="job_vacancy" onChange={handlerChange} ref={job_vacancyRef}
                            MenuProps={{
                                PaperProps: {
                                    style: {
                                        maxHeight: 200,
                                        overflowY: 'auto'
                                    }
                                }
                            }}
                            value={inputs.job_vacancy}
                            error={inputs.job_vacancy?.toString().trim() === ''}
                        >
                            {
                                job.data.list.length > 0 ?
                                    job.data.list.map((v,k) => (
                                        <MenuItem value={v.job_id} key={k}>
                                            {v.name}
                                        </MenuItem>
                                    ))
                                :
                                    <MenuItem disabled>
                                        🚫 No job vacancies found.
                                    </MenuItem>
                            }
                        </Select>
                    </FormControl>
                :

                    <TextField label="Job Vacancy" size='small' name="job_vacancy" onChange={handlerChange} ref={job_vacancyRef}
                        value={inputs.job_vacancy}
                        error={inputs.job_vacancy?.toString().trim() === ''}
                    />
            }
            <Box display="flex" alignItems="center" justifyContent="space-between">
                <Typography fontWeight={600}>Qualifications</Typography>
                {
                    !inputs.with_job_acc &&
                        <Box component={IconButton} onClick={() => handlerAddRemove('add')}>
                            <AddBox1 stroke="#2D503E" width={20} />
                        </Box>
                }
            </Box>
            {
                (inputs.with_job_acc && inputs.job_vacancy ? job.data.qualification : inputs.qualification).map((v, i) => (
                    <Box display="flex" alignItems="center" justifyContent="space-between" gap="8px" key={i}>
                        <TextField size='small' name="qualification" fullWidth onChange={(e) => handlerQualiChange(e, i)}
                            value={v.value} error={v.stat} 
                            multiline
                            maxRows={2}
                            disabled={inputs.with_job_acc}
                            ref={qualificationRef}
                        />
                        {
                            !inputs.with_job_acc && inputs.qualification.length > 1 &&
                                <Box component={IconButton} onClick={() => handlerAddRemove('remove', i)}>
                                    <Remove sx={{ color: '#FA3E3E' }} />
                                </Box>
                        }
                    </Box>
                ))
            }
            <Typography fontWeight={600}>Features Image</Typography>
            <Box display="flex" flexDirection="column" alignItems="center" gap="16px" position="relative">
                <IconButton
                    size="small"
                    onClick={() => form.set(prev => ({ ...prev, ft_image: { value: '', object: '', size: '', type: '', } }))}
                    sx={{
                        position: 'absolute',
                        top: -20,
                        right: '25%',
                        bgcolor: '#fff',
                        '&:hover': { bgcolor: '#f8d7da' },
                        border: '1px solid #ccc',
                        padding: '2px',
                        zIndex: 1,
                    }}
                >
                    <Close fontSize="small" />
                </IconButton>
                {
                    inputs.ft_image &&
                        <Avatar variant="square" src={inputs.ft_image.object === "" ? inputs.ft_image.value : inputs.ft_image.object} alt="features-img" 
                            sx={{width: 120, height: 120, '& img': { objectFit: 'contain' } }}
                        />
                }
                <label htmlFor='ft_image'>
                    <Button variant='contained' component="span" ref={ft_imageRef}
                        sx={{
                            bgcolor: '#f0f0f0',
                            color: '#000',
                            '&:hover': { bgcolor: '#e0e0e0' },
                        }}
                    >
                        Change
                    </Button>
                </label>
                <input type='file' accept="image/*" id="ft_image" hidden name='ft_image' onChange={handlerChange} />
            </Box>
            {
                inputs.with_job_acc &&
                    <>
                        <TextField label="POFJob Link" size='small' name="link" disabled
                            value={jobLink}
                            InputProps={{
                                endAdornment: (
                                <InputAdornment position="end">
                                    <Tooltip title={copied.data ? "Copied!" : "Copy to clipboard"}>
                                    <IconButton onClick={handleCopy}>
                                        <ContentCopy fontSize="small" />
                                    </IconButton>
                                    </Tooltip>
                                </InputAdornment>
                                ),
                            }}
                        />
                        <Typography fontWeight={600}>QR Code</Typography>
                        <Box display="flex" justifyContent="center">
                            <QRCodeSVG value={`${process.env.REACT_APP_CAREER_JOB_URL}/${window.btoa(inputs.job_vacancy)}`} size={150} level="H" />
                        </Box>
                    </>
            }
            <Box display="flex" alignItems="center" justifyContent="space-between">
                <Typography fontWeight={600}>Violator</Typography>
                <Box display="flex" alignItems="center" gap="8px">
                    <Checkbox name="violator" checked={inputs.violator} onChange={handlerChange} />
                    <Typography fontSize={14}>Show</Typography>
                </Box>
            </Box>
            <Box display="flex" flexDirection="column" alignItems="center" gap="16px">
                <img src={inputs.violator_image.object} alt="Vector-img" width={113.74} height={32} />
                <label htmlFor='violator_image'>
                    <Button variant='contained' component="span" 
                        sx={{
                            bgcolor: '#f0f0f0',
                            color: '#000',
                            '&:hover': { bgcolor: '#e0e0e0' },
                        }}
                    >
                        Change
                    </Button>
                </label>
                <input type='file' accept="image/*" id="violator_image" hidden name='violator_image' onChange={handlerChange} />
            </Box>
        </Box>
    )
}
